
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const _components = {
    h3: "h3",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h3, {
      children: "Overview"
    }), "\n", _jsx(_components.p, {
      children: "Constraint solver"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


export const metadata = {"size":"0.0 KB","lastModified":"12/22/2025","path":"/opt/render/project/src/packages/app/src/blog/protologic/constraint-solver/post.mdx"};
export const raw = "### Overview\n\nConstraint solver\n";
